export default "__VITE_ASSET__BSl2UD20__"